import { RouteName } from '../constants/routeNames';

export const reportDetailRoutes = [
  {
    path: 'details',
    name: RouteName.ReportDetails,
    component: () => import('../../views/report-details/ReportDetails.vue')
  },
  {
    path: 'forms/:formId',
    name: RouteName.ReportForms,
    component: () => import('../../views/report-details/ReportForms.vue')
  },
  {
    path: 'import',
    name: RouteName.ReportImport,
    component: () => import('../../views/report-details/ReportImport.vue')
  },
  {
    path: 'documents',
    name: RouteName.ReportDocuments,
    component: () => import('../../views/report-details/ReportDocuments.vue')
  },
  {
    path: 'activities',
    name: RouteName.ReportActivities,
    component: () => import('../../views/report-details/ReportActivities.vue')
  },

  {
    path: 'notes',
    name: RouteName.ReportNotes,
    component: () => import('../../views/report-details/ReportNotes.vue')
  },
  {
    path: 'validation',
    name: RouteName.ReportValidation,
    component: () => import('../../views/report-details/ReportValidation.vue')
  }
];
